export const restModelCreator = (Model, response) => {
  return !Array.isArray(response)
    ? new Model(response)
    : response.map(json => new Model(json));
};
